<template>
    <div>
        <div class="header-continer">
            <i class="material-icons arrow" @click="handleBack">arrow_back</i>
            <Header></Header>
            <div class="search-header-container">
                <SearchBar @search="updateSearchQuery" @search-status="handleHideNavbar"/> 
            </div>
        </div>
        <div v-if="isNavBarVisible" class="navbar-container" :class="{ 'hidden': isNavBarHidden }">
            <NavBar @update:selectedCategory="handleCategoryUpdate" />
        </div>
        <div class="category-page" :class="{ 'menu-completo': title === 'Menu completo' }">
            <Banner></Banner>
            <h1>{{ category }}</h1>
            <CardProduct v-for="(product, index) in filteredProducts" :key="index" :image_url="product.image_url"
                :name="product.name" :price="product.price" :description="product.description" />
        </div>
        <LoadingAnimation v-if="loading"></LoadingAnimation>
    </div>
</template>

<script>
import { fetchAllDishes, fetchDishesByCategory } from '@/api/DishesAPI'
import LoadingAnimation from '@/components/generic/LoadingAnimation.vue';
import Header from '@/components/homepage/Header.vue';
import Banner from '@/components/homepage/Banner.vue';
import CardProduct from '@/components/menupage/CardProduct';
import SearchBar from '@/components/menupage/SearchBar.vue';
import NavBar from '@/components/menupage/NavBar.vue';

export default {
    components: {
        LoadingAnimation,
        Header,
        Banner,
        CardProduct,
        SearchBar,
        NavBar,
    },
    data() {
        return {
            products: [],
            filteredProducts: [],
            loading: false,
            searchQueryFromParent: '',
            isNavBarHidden: false,
            isNavBarVisible: false,
            prevScrollPosition: 0,
            category: "Menu"
        }
    },
    props: ['title'],
    async mounted() {
        window.addEventListener('scroll', this.handleScroll);
        if (this.title === 'Menu completo') {
            this.products = await fetchAllDishes();
            this.isNavBarVisible = true;
        } else {
            this.loading = true;
            this.products = await fetchDishesByCategory(this.title);
            this.loading = false;
            this.isNavBarVisible = false;
        }
        this.filteredProducts = this.products;
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        },
        updateSearchQuery(query) {
            if (query === '') {
                this.filteredProducts = this.products;
            } else {
                this.searchQueryFromParent = query;
                this.filteredProducts = this.filterProducts(query);
            }
        },
        filterProducts(query) {
            return this.products.filter(product =>
                product.name.toLowerCase().includes(query.toLowerCase())
            );
        },
        handleCategoryUpdate(category) {
            this.category = category;
            if (category === 'Menu') {
                this.filteredProducts = this.products;
            } else {
                this.filteredProducts = this.products.filter(product =>
                    product.category.toLowerCase() === category.toLowerCase()
                );
            }
        },
        handleScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.isNavBarHidden = currentScrollPosition > this.prevScrollPosition && currentScrollPosition > 60;
            this.prevScrollPosition = currentScrollPosition;
        },
        handleHideNavbar(searchStatus) {
    const arrowIcon = document.querySelector('.arrow');
    const navbarContainer = document.querySelector('.navbar-container');

    if (arrowIcon && navbarContainer) {
        if (searchStatus) {
            arrowIcon.classList.add('arrow-hidden');
            navbarContainer.classList.add('navbar-hidden');
        } else {
            navbarContainer.classList.remove('navbar-hidden');
            arrowIcon.classList.remove('arrow-hidden');
        }
    } else {
        console.error('Arrow icon or navbar container not found in DOM.');
    }
        }}
};
</script>

<style scoped>
.hidden {
    position: fixed !important;
    top: 0px !important;
    transition: top 0.3s linear;
}

.arrow {
    font-size: 40px;
    color: var(--text-color);
    position: fixed;
    left: 10px;
    top: 10px;
    z-index: 1000;
}

.arrow-hidden{
    z-index: 999;
}
.category-page {
    position: absolute;
    background-color: var(--background-color);
    min-height: 100vh;
    width: 100vw;
}

.category-page.menu-completo {
    padding-top: 60px;
}

.category-page h1 {
    text-align: center;
    color: var(--text-color);
    margin-bottom: 50px;
}

.navbar-container {
    position: fixed;
    top: 60px;
    width: 100%;
    z-index: 1000;
    transition: top 0.3s linear;
}

.search-header-container{
    height: 60px;
    position: fixed;
    top: 0px;
    padding-left: 85%;
    z-index: 999;
}

.navbar-container.navbar-hidden {
    display: none; 
}

</style>